import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import {
  showPage as showPageAction,
  goBack as goBackAction,
  goBackDone as goBackDoneAction,
  hideAll as hideAllAction,
} from '../modules';

const MobileNavigationContainer = ({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
);

const mapStateToProps = ({ navigation, content }) => ({
  navigation: {
    ...navigation,
    pages: R.pathOr([], ['navigation', 'pages'], content),
  },
});

const mapDispatchToProps = dispatch => ({
  showPage: slug => dispatch(showPageAction(slug)),
  goBack: () => dispatch(goBackAction()),
  goBackDone: () => dispatch(goBackDoneAction()),
  hideAll: () => dispatch(hideAllAction()),
});

MobileNavigationContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileNavigationContainer);
